<template>
	<div class="display">
		<div class="state-head">气象站状态（{{geted?state.location:'加载中'}}）<div class="time" v-if="now_time">{{$moment(now_time*1000).format('YYYY-MM-DD HH:mm:ss')}}</div></div>
		<div class="state-content">
			<el-row :gutter="10">
				<el-col :xs="24" :sm="24" v-if="geted">

					<div class="state-row1-title">环境指数</div>
					<el-row class="state-row1" :gutter="10">
						<StateBlock v-for="(item, index) in ['空气温度','空气湿度','光照度','风速','风向','大气压','雨雪','雨量','噪声','PM2.5','PM10']"
												:key="index" :now_time="now_time" :tag="item" :obj="state[item]"></StateBlock>
					</el-row>

					<div class="state-row1-title">土壤指数</div>
					<el-row class="state-row1" :gutter="10">
						<StateBlock v-for="(item, index) in ['土壤温度','土壤湿度','土壤导电率','土壤氮','土壤磷','土壤钾','土壤PH']"
												:key="index" :now_time="now_time" :tag="item" :obj="state[item]"></StateBlock>
					</el-row>

					<div class="state-row1-title">气体指数</div>
					<el-row class="state-row1" :gutter="10">
						<StateBlock v-for="(item, index) in ['二氧化碳','氧气','一氧化碳','氨气','甲醛','硫化氢','臭氧','二氧化硫','氢气','甲烷']"
												:key="index" :now_time="now_time" :tag="item" :obj="state[item]"></StateBlock>
					</el-row>


				</el-col>
				<el-col :xs="24" :sm="24" >
					<div id="chart1" :style="{width: '100%', height: '250px'}"></div>
				</el-col>
				<el-col :xs="24" :sm="24" >
					<div id="chart4" :style="{width: '100%', height: '250px'}"></div>
				</el-col>
				<el-col :xs="24" :sm="24" >
					<div id="chart2" :style="{width: '100%', height: '250px'}"></div>
				</el-col>
        <el-col :xs="24" :sm="24" >
          <div id="chart5" :style="{width: '100%', height: '250px'}"></div>
        </el-col>
        <el-col :xs="24" :sm="24" >
          <div id="chart3" :style="{width: '100%', height: '250px'}"></div>
        </el-col>
			</el-row>
			<div class="api-time" v-if="api_time">{{$moment(api_time*1000).format('HH:mm:ss')}}</div>

		</div>




	</div>
</template>

<script>
	import {formatTimeToStr} from "@/util/date";
	import StateBlock from "@/components/StateBlock";

	export default {
	name: 'Display',
	components: { StateBlock},
	mounted(){
	},
	data() {
		return{
			station_id:0,
			now_time:0,
			api_time:0,
			state:{},
			geted:false,
			chartData: {}
		}
	},
	created: function () {
		this.station_id=this.$route.params.id;
		// `this` 指向 vm 实例
		this.getData();
		let that = this;
		setInterval(()=>{that.getData();},10000)
		setInterval(()=>{that.now_time=new Date().getTime()/1000;},1000)
	},
	methods: {
		getData(){
			let that = this;
			this.$api.getState(that.station_id)
							.then(res =>{
								console.log(res);
								this.geted = true;
								if(res.status === 200){
									let data = res.data.data;
									that.state = {}
									that.api_time = new Date().getTime()/1000;

									//处理最新状态
									for (let d of data.newest_state) {
										that.state.location = d["station_name"]
										//处理最新更新时间
										// if(!that.state.time || that.state.time<d["collect_time"]){
										//   that.state.time=d["collect_time"]
										//   let formattxt = 'yyyy-MM-dd hh:mm:ss'
										//   if(formatTimeToStr(d["collect_time"]*1000,'yyyy-MM-dd') === formatTimeToStr(new Date().getTime(),'yyyy-MM-dd')) formattxt='hh:mm:ss'
										//   that.state.timestr=formatTimeToStr(d["collect_time"]*1000,formattxt)
										//
										// }
										let value=d["collect_data"]
										if(d["field_name"] === '风向'){
											//处理风向
											value = that.handelwd(value);
										}else if(d["field_name"] === '雨量'){
											//处理非今天雨量
											if(formatTimeToStr(d["collect_time"]*1000,'yyyy-MM-dd') != formatTimeToStr(new Date().getTime(),'yyyy-MM-dd')) value=0;
										}else if(d["field_name"] === '雨雪'){
											//处理雨雪
											value=value?'下雨中':'无雨';
										}

										that.state[d["field_name"]] = {value:value,time:d["collect_time"],unit:d["field_unit"]};

									}
									//处理过去24小时温度
									let x=[],y1=[],y2=[]
									for(let i =-1 ; i<24;i++){
										let timekey = formatTimeToStr(new Date().getTime()-i*3600000,'yyyyMMddhh')
										x.unshift(formatTimeToStr(new Date().getTime()-i*3600000,'h时'))
										y1.unshift(data.airTemp24h[timekey+'-1'])
										y2.unshift(data.soilTemp24h[timekey+'-8'])
										// console.log(timekey)
									}
									that.drawChart1(x,y1,y2);


									//处理过去24小时湿度
									x=[],y1=[],y2=[]
									for(let i =-1 ; i<24;i++){
										let timekey = formatTimeToStr(new Date().getTime()-i*3600000,'yyyyMMddhh')
										x.unshift(formatTimeToStr(new Date().getTime()-i*3600000,'h时'))
										y1.unshift(data.airRH24h[timekey+'-2'])
										y2.unshift(data.soilRH24h[timekey+'-9'])
										// console.log(timekey)
									}
									that.drawChart4(x,y1,y2);

									//处理过去7天光照
									x=[],y1=[]
									for(let i =0 ; i<7;i++){
										let timekey = formatTimeToStr(new Date().getTime()-i*3600000*24,'yyyyMMdd')
										x.unshift(formatTimeToStr(new Date().getTime()-i*3600000*24,'M-d'))
										y1.unshift(data.lux7d[timekey+'-4']/1000)
										// console.log(timekey)
									}
									that.drawChart2(x,y1);

									//处理过去30天降雨
									x=[],y1=[]
									for(let i =0 ; i<30;i++){
										let timekey = formatTimeToStr(new Date().getTime()-i*3600000*24,'yyyyMMdd')
										x.unshift(formatTimeToStr(new Date().getTime()-i*3600000*24,'M-d'))
										y1.unshift(data.rainfall30d[timekey+'-11'])
										// console.log(timekey)
									}
									that.drawChart3(x,y1);

                  //处理过去24小时降雨
                  x=[],y1=[]
                  let previous = 0
                  for(let i =-1 ; i<25;i++){
                    let timekey = formatTimeToStr(new Date().getTime()-(24-i)*3600000,'yyyyMMddhh')
                    if( i > -1){
                      x.push(formatTimeToStr(new Date().getTime()-(24-i)*3600000,'h时'))
                      let p1 = data.rainfall24h[timekey+'-11'] - previous
                      y1.push(p1>0 ? p1 : 0)
                    }
                    previous = timekey.substring(8) === '23'? 0: data.rainfall24h[timekey+'-11']
                    console.log(timekey,previous)
                  }
                  that.drawChart5(x,y1);

									console.log( that.state)
								}
							})
							.catch(res =>{
								console.log(res)
							})
		},
		handelwd(num){
			//处理风向
			// let wd=["北","东北","东","东南","南","西南","西","西北"];
			// let d1= Math.round(d/45);
			// return wd[d1];
			let windData=[
				{name:'北风',vuale:[0,11.25]},
				{name:'北风',vuale:[348.76,360]},
				{name:'东北偏东',vuale:[11.26,33.75]},
				{name:'东北风',vuale:[33.76,56.25]},
				{name:'东北偏东',vuale:[56.26,78.75]},
				{name:'东风',vuale:[78.76,101.25]},
				{name:'东南偏东',vuale:[101.26,123.75]},
				{name:'东南风',vuale:[123.76,146.25]},
				{name:'东南偏南',vuale:[146.26,168.75]},
				{name:'南风',vuale:[168.76,191.25]},
				{name:'西南偏南',vuale:[191.26,213.75]},
				{name:'西南风',vuale:[213.76,236.25]},
				{name:'西南偏西',vuale:[236.26,258.75]},
				{name:'西风',vuale:[258.76,281.25]},
				{name:'西北偏西',vuale:[281.26,303.75]},
				{name:'西北风',vuale:[303.76,336.25]},
				{name:'西北偏北',vuale:[336.26,348.75]},
			]

			return windData.find(_=> num>=_.vuale[0]&&num<=_.vuale[1]).name



		},
		random(len, min, max , bili=1){
			let arr=[]
			for (var i = 1; i <= 24; i++) {
				arr.push((Math.floor(Math.random() * (max - min)) + min)/bili)
			}
			return arr
		},
		drawChart1(x,y1,y2){
			// 基于准备好的dom，初始化echarts实例
			if(!this.chart1){
				this.chart1 = this.$echarts.init(document.getElementById('chart1'))
			}
			// 绘制图表
			let option = {
				title: {text: '过去24小时温度',},
				grid: {},
				legend: {data: ['空气温度', '土壤温度'], right: 10, top: 1},
				xAxis: {
					type: 'category',
					boundaryGap: false,
					data: x
				},
				yAxis: [{
					name: '温度(°C)',
					// max: 50,
					// min: 15,
					type: 'value',
				}],
				series: [{
					name: '空气温度',
					data: y1,
					type: 'line',
					smooth: true
				},{
					name: '土壤温度',
					color: '#2c3e50',
					data:  y2,
					type: 'line',
					smooth: true
				}]
			}
			this.chart1.setOption(option);
		},
		drawChart4(x,y1,y2){
			// 基于准备好的dom，初始化echarts实例
			if(!this.chart4){
				this.chart4 = this.$echarts.init(document.getElementById('chart4'))
			}
			// 绘制图表
			let option = {
				title: {text: '过去24小时湿度',},
				grid: {},
				legend: {data: ['空气湿度', '土壤湿度'], right: 10, top: 1},
				xAxis: {
					type: 'category',
					boundaryGap: false,
					data: x
				},
				yAxis: [{
					name: '湿度(%)',
					// max: 50,
					// min: 15,
					type: 'value',
				}],
				series: [{
					name: '空气湿度',
					data: y1,
					type: 'line',
					smooth: true
				},{
					name: '土壤湿度',
					color: '#2c3e50',
					data:  y2,
					type: 'line',
					smooth: true
				}]
			}
			this.chart4.setOption(option);
		},
		drawChart2(x,y1){
			// 基于准备好的dom，初始化echarts实例
			if(!this.chart2){
				this.chart2 = this.$echarts.init(document.getElementById('chart2'))
			}
			// 绘制图表
			let option = {
				title: {text: '过去7天光照度',},
				grid: {},
				// legend: {data: ['空气温度', '土壤温度'], right: 10, top: 1},
				xAxis: {
					type: 'category',
					boundaryGap: false,
					data: x
				},
				yAxis: [{
					name: '光照度(kLux)',
					// max: 50,
					// min: 15,
					type: 'value',
				}],
				series: [{
					name: '光照度',
					data: y1,
					color: '#e2cd00',
					type: 'line',
					areaStyle: {},
					smooth: true
				}]
			}
			this.chart2.setOption(option);
		},
    drawChart3(x,y1){
      // 基于准备好的dom，初始化echarts实例
      if(!this.chart3){
        this.chart3 = this.$echarts.init(document.getElementById('chart3'))
      }
      // 绘制图表
      let option = {
        title: {text: '过去30天降雨量',},
        grid: {},
        // legend: {data: ['空气温度', '土壤温度'], right: 10, top: 1},
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: x
        },
        yAxis: [{
          name: '降雨量(mm)',
          // max: 50,
          // min: 15,
          type: 'value',
        }],
        series: [{
          name: '降雨量',
          data: y1,
          color: '#4484ff',
          type: 'bar',
          areaStyle: {},
          smooth: true
        }]
      }
      this.chart3.setOption(option);
    },
    drawChart5(x,y1){
      // 基于准备好的dom，初始化echarts实例
      if(!this.chart5){
        this.chart5 = this.$echarts.init(document.getElementById('chart5'))
      }
      // 绘制图表
      let option = {
        title: {text: '每小时降雨量',},
        grid: {},
        // legend: {data: ['空气温度', '土壤温度'], right: 10, top: 1},
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: x
        },
        yAxis: [{
          name: '降雨量(mm)',
          // max: 50,
          // min: 15,
          type: 'value',
        }],
        series: [{
          name: '降雨量',
          data: y1,
          color: '#4484ff',
          type: 'bar',
          areaStyle: {},
          smooth: true
        }]
      }
      this.chart5.setOption(option);
    }
	}
}
</script>

<style lang="scss">
.display {
	.state-head{
		position: relative;
		background: #409EFF;
		font-size: 18px;
		line-height: 50px;
		color: #fff;
		padding-left: 12px;
		.time{
			position: absolute;
			bottom:0;
			right:0;
			padding: 4px 14px;
			font-size: 12px;
			line-height: initial;
			color: #c9e3ff;
		}
	}
	.state-content{
		position: relative;
		padding:0 12px 12px;

	}
	.state-row1{
		margin-bottom: 12px;
	}
	.state-row1-title{
		background: #f5f5f5;
		font-weight: 700;
		font-size: 18px;
		padding: 18px 12px 8px;
		margin: 0 -12px 12px;
	}
	.api-time{
		right: 0;
		padding: 0 14px 0;
		font-size: 12px;
		color: #dadada;
		position: absolute;
		bottom: -30px;
	}

}

</style>
